import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent, DocumentType } from '../../../../const';
import { DtoClientAccount, DtoClientAdmin } from '../../../../models/mat-account.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { HelperMethods } from '../../../common/helper-methods.service';
import { MatAccountService } from '../../../mat-account/mat-account.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../../../../shared/services/shared.service';
import { ConfirmDialogComponent } from '../../../mat-account/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { SchoolService } from '../../../school/school.service';

interface MatAdminUploadFileList {
  adminMailID: string | null;
  files: File[];
}

@Component({
  selector: 'app-edit-admin',
  templateUrl: './edit-admin.component.html'

})
export class EditAdminComponent implements OnInit, OnDestroy {
  matAdmin: DtoClientAdmin = {} as DtoClientAdmin;
  createMatAdminForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]),
    phoneNumber: new FormControl('', 
    [this.helperMethods.PhoneNumberValidator()])
  });
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  isEditUser: boolean = false;
  canEditUser: boolean = false;
  clientAccountId: number = 0;
  @ViewChild('editMatAdminfileInput') editMatAdminfileInput: ElementRef | undefined;
  @ViewChild('uploadFileInput') uploadFileInput: ElementRef | undefined;
  isBulkUpload : boolean = false;
  excelData: any[] = [];
  matAdminCreationLimit: number = 0;
  AdminUploadFileList: MatAdminUploadFileList[] = [];
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  subscription: Subscription = new Subscription();
  selectedFileCount: number = 0;
  isAccountActivated: boolean = false;
  isActive: boolean = true;

  constructor(
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<EditAdminComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matAccountService: MatAccountService,
    public helperMethods: HelperMethods,
    private toasterService: ToastrService,
    private sharedService: SharedService,
    private schoolService: SchoolService
  ) {  }

  ngOnInit() {
    this.isAccountActivated = false;
    this.isActive = true;
    this.matAdmin = this.data;
    if(this.matAdmin.emailId){
      this.isEditUser = true;
      this.isActive = this.matAdmin.isActive??true;
      
      this.canEditUser = this.isActive;
      this.isAccountActivated = this.matAdmin.isAccountActivated??false;
      if(this.data.isBulkUploadEdit){
        this.isEditUser = false;
      }
      this.createMatAdminForm.patchValue(this.data);
      this.createMatAdminForm.controls['email'].setValue(this.data.emailId);
      this.setPhoneNumber(this.data.countryCode?.toString()!, this.data.phoneNumber?.toString()!);
    }
    else{
      this.canEditUser = true;
      this.isEditUser = false;
      this.clientAccountId = Number(this.data.clientAccountId);
      this.matAdminCreationLimit = Number(this.data.numberOfClientAdminsDifference);
    }
    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      if(data){
        this.uploadFromLocal(data, true);
      }
    }));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  resendActivation(){
    this.schoolService.resendActivationInvite(this.data.userId)
    .subscribe({
      next: (response: any) => {
        if(response.isSuccess===false)
          this.toasterService.error(`${this.data.emailId}: ${response.message}`, "Resend Activation Invite");
        else
          this.toasterService.success(`Activation invite resent to ${this.data.emailId}`, "Resend Activation Invite");
      },
      error: (err: any) => {
        this.toasterService.error(`Activation invite could not be resent to ${this.data.emailId}`, "Resend Activation Invite");
      }
    });  
  }

  setPhoneNumber(countryCode: string, nationalNumber: string) {
    let examplePhoneNumber = `+${countryCode}${nationalNumber}`;
    let formattedNumber = this.phoneNumberUtil.format(
      this.phoneNumberUtil.parse(examplePhoneNumber),
      PhoneNumberFormat.INTERNATIONAL
    );
    this.createMatAdminForm.patchValue({ phoneNumber: formattedNumber });
  }

  createMatAdmin(){
    let userDetails = JSON.parse(JSON.stringify(this.createMatAdminForm.value));
    
    let parsedNumber = this.phoneNumberUtil.parse(this.createMatAdminForm.get('phoneNumber')?.value);
        let countryCode = parsedNumber.getCountryCode();
        let nationalNumber = parsedNumber.getNationalNumber();

    userDetails.countryCode = countryCode;
    userDetails.phoneNumber = nationalNumber;
    userDetails.username = this.createMatAdminForm.controls['firstName'].value.trim() + this.createMatAdminForm.controls['lastName'].value.trim();
    userDetails.emailId = userDetails.email;
    const AdminAccountformData = new FormData();
    if(this.AdminUploadFileList.length){
      this.AdminUploadFileList[0].adminMailID = userDetails.email;
  
      userDetails.UploadedFiles = this.AdminUploadFileList[0].files;
      this.AdminUploadFileList[0].files.forEach((file: File) => {
          AdminAccountformData.append('file', file, file.name);
      });
    }

    if(this.data.isBulkUploadEdit)
    {
      this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, updatedDetails: userDetails} );
    }
    else if(this.isEditUser){
      this.matAccountService.editMatAdmin(userDetails).subscribe((response: any) => {
        if (response) {
          if(this.AdminUploadFileList.length && this.AdminUploadFileList[0].files.length){
            this.uploadDocument(AdminAccountformData, DocumentType.ClientAdmin, this.matAdmin.clientAdminId.toString());
          }
            this.toasterService.success('MAT admin details updated successfully', 'Success');
            this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
    else{
      this.matAccountService.createMatAdmin([userDetails], this.clientAccountId).subscribe((response: any) => {
        if (response.isSuccess) {
          if(this.AdminUploadFileList.length && this.AdminUploadFileList[0].files.length){
            this.matAccountService.getAdminDetails(this.clientAccountId).subscribe((response: DtoClientAccount | any) => {
              if (response != null) {
                  response.clientAdmins.forEach((admin: DtoClientAdmin) => {
                    let matchedAdminUploadFileList = this.findAdminUploadFileListByMail(admin.emailId!);
                    if (matchedAdminUploadFileList) {
                      let formData = new FormData();
                      matchedAdminUploadFileList.files.forEach((file: File) => {
                        formData.append('file', file, file.name);
                      });
                      this.uploadDocument(formData, DocumentType.ClientAdmin, admin.clientAdminId.toString());
                    }
                  });
              }
            })
          }
            this.toasterService.success('MAT admin details created successfully', 'Success');
            this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        }
      }, (errorResponse: HttpErrorResponse) => {
        if(errorResponse.error){
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
  }

  closePopup(){
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }

  getFilesForAdmin(): File[] {
    const adminUploadFileList = this.AdminUploadFileList[0];
    return adminUploadFileList ? adminUploadFileList.files || [] : [];
  }

  findAdminUploadFileListByMail(emailId: string): MatAdminUploadFileList | undefined {
    return Object.values(this.AdminUploadFileList).find(adminUploadFileList => adminUploadFileList.adminMailID === emailId);
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  uploadFromLocal(event: Event, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.getFilesForAdmin());
      this.dialog.open(ConfirmDialogComponent, { width: '675px', data: {
        hideUpload: false,
        isParentUpload: true
      }}).afterClosed().subscribe(() => {
        this.selectedFileCount = this.getFilesForAdmin().length;
      });
    }
    if (this.editMatAdminfileInput) {
      this.editMatAdminfileInput.nativeElement.click();
    }
  }

  onFileSelected(event: any) {
    if (!this.AdminUploadFileList[0]) {
      this.AdminUploadFileList[0]= { adminMailID: null, files: [] };
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if(event.target.files[i].size <= this.maxSize){
            let _object: File = event.target.files[i];

            this.AdminUploadFileList[0].files.push(_object);
          }
          else{
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.AdminUploadFileList[0].files);
      this.selectedFileCount = this.AdminUploadFileList[0].files.length;
      this.editMatAdminfileInput!.nativeElement.value = null;
    }
  }


  bulkUpload(){
    if (this.uploadFileInput) {
      this.uploadFileInput.nativeElement.click();
    }
  }

  loadExcelData(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Assuming your data starts from the second row (index 1) 
      const processedData = data.slice(1)
      .filter((row: any[]) => row.some(cell => cell !== undefined && cell !== null && cell !== ''))
      .map((row: any[]) => ({
        firstName: row[1] || '',
        lastName: row[2] || '',
        emailId: row[3] || '',
        countryCode: row[4] || '',
        phoneNumber: row[5] || ''
      }));

      this.excelData = processedData.slice(0, this.matAdminCreationLimit);
    };
    reader.readAsBinaryString(target.files[0]);
    this.isBulkUpload = true;
    event.target.value = null;
  }

  areAllDetailsFilled(): boolean {
    return this.excelData.every(detail => 
      detail.firstName && 
      detail.lastName && 
      detail.emailId && 
      detail.countryCode && 
      detail.phoneNumber
    );
  }

  downloadFile(): void {
    const blobName = 'TemplateForBulkUploadMatAdmin.xlsx'; // Specify the file name you want to download
    this.schoolService.downloadFile(blobName).subscribe((response: any) => {

      var url = response.blobUrl.toString();
      for (var i = 0; i < url.length; i++) {
        url = url.replace("~", "");
        url = url.replace("//", "%2F%2F");
        url = url.replace("/", "%2F");
        url = url.replace(":", "%3A");
    }
    console.log(url);
     var ViewDocumentUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
     window.open(ViewDocumentUrl, "_blank");
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  openEditMatAdminDialog(userDetail: any = {}, index: number){
    userDetail.isBulkUploadEdit = true;
    this.dialog.open(EditAdminComponent, {
      width: '800px',
      data: userDetail || {}
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS && popupEvent?.updatedDetails){
          this.excelData[index].firstName = popupEvent?.updatedDetails.firstName;
          this.excelData[index].lastName = popupEvent?.updatedDetails.lastName;
          this.excelData[index].countryCode = popupEvent?.updatedDetails.countryCode;
          this.excelData[index].phoneNumber = popupEvent?.updatedDetails.phoneNumber;
          this.excelData[index].email = popupEvent?.updatedDetails.email;
          this.excelData[index].emailId = popupEvent?.updatedDetails.email;
          this.excelData[index].uploadedFiles = popupEvent?.updatedDetails.UploadedFiles;
          this.excelData[index].username = popupEvent?.updatedDetails.firstName.trim() + popupEvent?.updatedDetails.lastName.trim();
      }
    });
  }

  createBulkUsers(){
    if (!this.excelData || this.excelData.length === 0) {
      this.toasterService.error('No data found', 'Error');
      return;
    }

    this.matAccountService.createMatAdmin(this.excelData, this.clientAccountId).subscribe((response: any) => {
      if (response.isSuccess) {
          this.matAccountService.getAdminDetails(this.clientAccountId).subscribe((response: DtoClientAccount | any) => {
            if (response != null) {
                response.clientAdmins.forEach((admin: DtoClientAdmin) => {
                  let matchedAdminUploadedFileList = this.findAdminUploadFileListByMailFromExcel(admin.emailId!);
                  if (matchedAdminUploadedFileList && matchedAdminUploadedFileList.length > 0) {
                    let formData = new FormData();
                    matchedAdminUploadedFileList.forEach((file: File) => {
                      formData.append('file', file, file.name);
                    });
                    this.uploadDocument(formData, DocumentType.ClientAdmin, admin.clientAdminId.toString());
                  }
                });
            }
          })
          this.toasterService.success('MAT admin details created successfully', 'Success');
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  deleteItem(index: number): void {
      this.excelData.splice(index, 1);
  }

  findAdminUploadFileListByMailFromExcel(email: string) {
    const matchingRecord = this.excelData.find((data: any) => data.emailId === email);
    return matchingRecord ? matchingRecord.uploadedFiles : null;
  }
}
